export { default as AssetClassCell } from './component';
